import React, {useState} from "react";
import {Col, Collapse, Divider, Form, Input, InputNumber, message, Radio, Row, Select, Switch, Tooltip,} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {mapCycle, mapCycleMonth} from "./mapData/mapCycle";
import {dayNewLeave} from "./mapData/mapDayNewLeave";
import {beforeThisDay} from "./mapData/beforeThisDay";
import {afterThisDay} from "./mapData/afterThisDay";
import DG_FormItem_LabelDetail from "../../../../../../custom/data-entry/form/Item/LabelDetail";
import DG_TreeSelect_Department from "../../../../../../custom/data-entry/tree-select/department/Department";
import DG_DatePicker from "../../../../../../custom/date-picker";

const {Panel} = Collapse;
const {Option} = Select;

const styleFormItem = {
    labelCol: {xxl: {span: 18}, xl: {span: 18}, lg: {span: 24}},
    wrapperCol: {xxl: {span: 6}, xl: {span: 6}, lg: {span: 24}},
    style: {height: "120px"}
}
const customerTitleAllLeaveFirstMonth = (t) =>{

    return (
        <>
            <div>
                {t("messageLeaveSetting.annualLeaveAccumulation")}
            </div>
            <div>{t("messageLeaveSetting.example")}:</div>
            <ul style={{marginLeft: 40}}>
                <li>{t("messageLeaveSetting.oldEmployeeLeaveGrant")}</li>
                <li> {t("messageLeaveSetting.newEmployeeLeaveGrant")}</li>
                <li>{t("messageLeaveSetting.recalculateLeaveMidMonth")}</li>
            </ul>
        </>
    )
}
function General(props) {
    const {t} = useTranslation();

    const monthFormat = 'MM/YYYY';

    const [valueSelect, setValueSelect] = useState([]);

    const cumulativeEndTime = [
        {
            name: t("tnp.components.salary.text183"),
            value: "next jan"
        },
        {
            name: t("tnp.components.salary.text184"),
            value: "next feb"
        },
        {
            name: t("tnp.components.salary.text185"),
            value: "next mar"
        },
        {
            name: t("tnp.components.salary.text186"),
            value: "next apr"
        },
        {
            name: t("tnp.components.salary.text187"),
            value: "next may"
        },
        {
            name: t("tnp.components.salary.text188"),
            value: "next june"
        },
        {
            name: t("tnp.components.salary.text189"),
            value: "next july"
        },
        {
            name: t("tnp.components.salary.text190"),
            value: "next aug"
        },
        {
            name: t("tnp.components.salary.text191"),
            value: "next sep"
        },
        {
            name: t("tnp.components.salary.text192"),
            value: "next oct"
        },
        {
            name: t("tnp.components.salary.text193"),
            value: "next nov"
        },
        {
            name: t("tnp.components.salary.text194"),
            value: "next dec"
        },
        {
            name: t("tnp.components.salary.text195"),
            value: "custom"
        },
        {
            name: t("tnp.components.salary.text196"),
            value: "no accumulation"
        }
    ]


    const selectProps = {
        mode: 'multiple',
        style: {
            width: '100%',
        },
        valueSelect,
        onChange: (newValue) => {
            setValueSelect(newValue);
        },
        maxTagCount: 'responsive',
        allowClear: true,
    }

    const [dayNewLeaveType, setDayNewLeaveType] = useState("")
    const chooseTypeDayNewLeave = (value) => {
        setDayNewLeaveType(value)
    }

    const [typeCumulative, setTypeCumulative] = useState("")
    const chooseTypeCumulative = (value) => {
        setTypeCumulative(value)
    }

    const [valueRadio, setValueRadio] = React.useState();
    const onChangeRadio = e => {
        setValueRadio(e.target.value);
    };

    const mapSelectCycle = mapCycle.map(item => <Option value={item.value}>{item.name}</Option>)
    const mapSelectCycleMonth = mapCycleMonth.map(item => <Option value={item.value}>{item.name}</Option>)
    const mapSelectDayNewLeave = dayNewLeave(t).map(item => <Option value={item.value}>{item.name}</Option>)
    const mapSelectCumulativeEndTime = cumulativeEndTime.map(item => <Option value={item.value}>{item.name}</Option>)
    const mapSelectBeforeThisDay = beforeThisDay(t).map(item => <Option value={item.value}>{item.name}</Option>)
    const mapSelectAfterThisDay = afterThisDay.map(item => <Option value={item.value}>{item.name}</Option>)

    const filterOption = (input, option) => {
        const normalizedInput = input.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const normalizedOption = option?.dataSearch.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

        return normalizedOption.includes(normalizedInput);
    };


    return (
        <div id={props.id}>
            <Row gutter={12} style={{padding: "0 16px"}}>
                <Col xxl={{span: 24}} xl={{span: 24}} lg={{span: 24}}>
                    <DG_FormItem_LabelDetail
                        label={t("leave-setting.leaveSettingName")}
                        labelDetail={t("leave-setting.leaveSettingNameDetails")}
                        name={"name"}
                        labelCol={{xxl: {span: 18}, xl: {span: 18}, lg: {span: 24}}}
                        wrapperCol={{xxl: {span: 6}, xl: {span: 6}, lg: {span: 24}}}

                    >
                        <Input/>
                    </DG_FormItem_LabelDetail>
                </Col>
            </Row>
            <Row gutter={12} style={{padding: "0 16px"}}>
                <Col span={24}>
                    <span>{t("leave-setting.timeApplication")}</span>
                    <Divider/>
                </Col>
            </Row>
            <Row gutter={12} style={{padding: "0 16px"}}>
                <Col xxl={{span: 24}} xl={{span: 24}} lg={{span: 24}}>
                    <DG_FormItem_LabelDetail
                        labelDetail={`${t("leave-setting.timeApplicationDetails1")}
                            ${t("leave-setting.timeApplicationDetails2")}
                            ${t("leave-setting.timeApplicationDetails3")}
                        `}
                        {...styleFormItem}
                    >
                        <Row gutter={12}>
                            <Col span={12}>
                                <div className={'mb-2 mt-3'}>
                                    {t("leave-setting.fromMonth")}
                                </div>
                                <div>
                                    <Form.Item
                                        name="startMonth"
                                    >
                                        <DG_DatePicker
                                            onChange={props.onChangeDatePickerStart}
                                            picker="month"
                                            format={monthFormat}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className={'mb-2 mt-3'}>
                                    {t("leave-setting.toMonth")}
                                </div>
                                <div>
                                    <Form.Item
                                        name="endMonth"
                                    >
                                        <DG_DatePicker
                                            onChange={props.onChangeDatePickerEnd}
                                            picker="month"
                                            format={monthFormat}
                                            style={{width: '100%'}}
                                        />
                                    </Form.Item>
                                </div>
                            </Col>
                        </Row>
                    </DG_FormItem_LabelDetail>
                </Col>
            </Row>
            <Collapse defaultActiveKey={[1, 2, 3]} ghost>
                <Panel
                    header={
                        <div>
                            <span>{t("leave-setting.applicableObject")}</span>
                            <Divider/>
                        </div>
                    }
                    key="1"
                >
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.departmentApplication")}
                                labelDetail={`${t("leave-setting.departmentApplicationDetails1")}
                                    ${t("leave-setting.departmentApplicationDetails2")}
                                `}
                                name="departmentIds"
                                {...styleFormItem}
                            >
                                <DG_TreeSelect_Department
                                    multiple
                                    maxTagCount={"responsive"}
                                />
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.positionApplication")}
                                labelDetail={`${t("leave-setting.positionApplicationDetails1")}
                                    ${t("leave-setting.positionApplicationDetails2")}
                                `}
                                name="positionIds"
                                {...styleFormItem}
                            >
                                <Select
                                    placeholder={t("leave-setting.choosePosition")}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={filterOption}
                                    allowClear
                                    {...selectProps}
                                >
                                    {props.dataSelectPosition}
                                </Select>
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.reasonLeave")}
                                labelDetail={`${t("leave-setting.reasonLeaveDetails1")}
                                    ${t("leave-setting.reasonLeaveDetails2")}
                                `}
                                name="reasonCodes"
                                {...styleFormItem}
                            >
                                <Select
                                    placeholder={t("leave-setting.chooseReasonLeave")}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={filterOption}
                                    allowClear
                                    {...selectProps}
                                >
                                    {props.dataSelectReasonLeave}
                                </Select>
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>
                </Panel>
                <Panel
                    header={
                        <div className="width-100-pc">
                            <span>{t("leave-setting.conditionsApply")}</span>
                            <Divider/>
                        </div>
                    }
                    key="2"
                >
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.contractType")}
                                labelDetail={`${t("leave-setting.contractTypeDetails1")}
                                    ${t("leave-setting.contractTypeDetails2")}
                                `}
                                name="contractTypeOnLeaveIds"
                                {...styleFormItem}
                            >
                                <Select
                                    placeholder={t("leave-setting.chooseContractType")}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={filterOption}
                                    allowClear
                                    {...selectProps}
                                >
                                    {props.dataSelectContractType}
                                </Select>
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.monthDid")}
                                labelDetail={t("leave-setting.monthDidDetails")}
                                name="contractMonthOnLeave"
                                {...styleFormItem}
                            >
                                <InputNumber style={{width: "100%"}}/>
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.dateStartCounted")}
                                labelDetail={`${t("leave-setting.dateStartCountedDetails1")}
                                    ${t("leave-setting.dateStartCountedDetails2")}
                                `}
                                name="dayStart"
                                initialValue={-1}
                                {...styleFormItem}
                            >
                                <Select
                                    dropdownStyle={{
                                        padding: '12px',
                                        minWidth: 350,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}
                                    placeholder={t("leave-setting.choosedayStartContractType")}
                                >
                                    {props.mapDayStartContractType}
                                </Select>
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>
                </Panel>
                <Panel
                    header={
                        <div className="width-100-pc">
                            <span>{t("leave-setting.generalInformation")}</span>
                            <Divider/>
                        </div>
                    }
                    key="3"
                >
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.maximumLeavePerYear")}
                                labelDetail={`${t("leave-setting.maximumLeavePerYearDetails1")}
                                    ${t("leave-setting.maximumLeavePerYearDetails2")}
                                `}
                                name="maximumLeave"
                                initialValue={12}
                                {...styleFormItem}
                            >
                                <InputNumber style={{width: "100%"}}/>
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>
                    <Row>
                        <Col
                            xxl={{span: 1}}
                            xl={{span: 1}}
                            lg={{span: 1}}
                        />
                        <Col
                            xxl={{span: 23}}
                            xl={{span: 23}}
                            lg={{span: 23}}
                        >
                            <Row gutter={12} style={{marginBottom: "10px"}}>
                                <Col span={24}>
                                    <span>{t("leave-setting.leavePerMonth")}</span>
                                </Col>
                            </Row>
                            <Row gutter={12}>
                                <Col
                                    xxl={{span: 24}}
                                    xl={{span: 24}}
                                    lg={{span: 24}}
                                >
                                    <Form.Item
                                        labelCol={{
                                            xxl: {span: 18},
                                            xl: {span: 18},
                                            lg: {span: 24},
                                        }}
                                        wrapperCol={{
                                            xxl: {span: 24},
                                            xl: {span: 24},
                                            lg: {span: 12},
                                        }}
                                        name="monthlyLeave"
                                        labelAlign="right"
                                        initialValue={1}
                                    >
                                        <Radio.Group onChange={onChangeRadio} value={valueRadio}>
                                            <div style={{marginBottom: "10px"}}>
                                                <Radio value={1}>
                                                    <span
                                                        style={{paddingRight: "10px"}}>{t("leave-setting.totalLeaveDivide12")}</span>
                                                    <Tooltip
                                                        placement="topLeft"
                                                        title={t(
                                                            "leave-setting.totalLeaveDivide12Details"
                                                        )}
                                                    >
                                                        <InfoCircleOutlined/>
                                                    </Tooltip>
                                                </Radio>
                                            </div>
                                            <div style={{marginBottom: "10px"}}>
                                                <Radio value={2}>
                                                    <span
                                                        style={{paddingRight: "10px"}}>{t("leave-setting.1LeavePerMonth")}</span>
                                                    <Tooltip
                                                        placement="topLeft"
                                                        title={t(
                                                            "leave-setting.1LeavePerMonthDetails"
                                                        )}
                                                    >
                                                        <InfoCircleOutlined/>
                                                    </Tooltip>
                                                </Radio>
                                            </div>
                                            <div>
                                                <Radio value={3}>
                                                    <span
                                                        style={{paddingRight: "10px"}}>{t("leave-setting.allLeaveFirstMonth")}</span>
                                                    <Tooltip
                                                        placement="topLeft"
                                                        title={customerTitleAllLeaveFirstMonth(t)}
                                                        overlayInnerStyle={{width: 500}}
                                                    >
                                                        <InfoCircleOutlined/>
                                                    </Tooltip>
                                                </Radio>
                                            </div>
                                        </Radio.Group>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={12}>
                                <Col
                                    xxl={{span: 24}}
                                    xl={{span: 24}}
                                    lg={{span: 24}}
                                >
                                    <DG_FormItem_LabelDetail
                                        label={t("leave-setting.cycleCountLeave")}
                                        labelDetail={`${t("leave-setting.cycleCountLeaveDetails1")}
                                            ${t("leave-setting.cycleCountLeaveDetails2")}`}
                                        labelCol={{xxl: {span: 13}, xl: {span: 13}, lg: {span: 24}}}
                                        wrapperCol={{xxl: {span: 11}, xl: {span: 11}, lg: {span: 24}}}
                                        // style={{height: "120px"}}
                                    >
                                        <Row gutter={12}>
                                            <Col span={3}/>
                                            <Col span={4}>
                                                <Form.Item
                                                    name={"cycle"}
                                                    initialValue={1}
                                                >
                                                    <Select>
                                                        {mapSelectCycle}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <span className={'mt-1'}>{t("leave-setting.toEndMonth")}</span>
                                            <Col span={4}>
                                                <Form.Item
                                                    name={"cycleMonth"}
                                                    initialValue={12}
                                                >
                                                    <Select>
                                                        {mapSelectCycleMonth}
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col span={7}>
                                                <Form.Item
                                                    name={"cycleYear"}
                                                    initialValue={"in year"}
                                                >
                                                    <Select>
                                                        <Option value={"in year"}>
                                                            {t("leaveSetting.inYear")}
                                                        </Option>
                                                        <Option value={"next year"}>
                                                            {t("leaveSetting.nextYear")}
                                                        </Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </DG_FormItem_LabelDetail>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {/*<Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.dayAddNewLeaveOfMonth")}
                                labelDetail={`${t("leave-setting.contractTypeDetails1")}
                                    ${t("leave-setting.contractTypeDetails2")}
                                `}
                                name="dayNewLeave"
                                initialValue={"first"}
                                {...styleFormItem}
                            >
                                <Select
                                    placeholder={t("placeholderLS.day")}
                                    onChange={(e) => chooseTypeDayNewLeave(e)}
                                >
                                    {mapSelectDayNewLeave}
                                </Select>
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>*/}
                    {/*{
                        dayNewLeaveType === "enough" || props.dayNewLeaveProps === "enough" ? <Row gutter={12}>
                            <Col
                                xxl={{span: 24}}
                                xl={{span: 24}}
                                lg={{span: 24}}
                            >
                                <Form.Item
                                    labelCol={{
                                        xxl: {span: 18},
                                        xl: {span: 18},
                                        lg: {span: 24},
                                    }}
                                    wrapperCol={{
                                        xxl: {span: 6},
                                        xl: {span: 6},
                                        lg: {span: 12},
                                    }}
                                    label={
                                        <div>
                                            <p className="margin-b-5">
                                                {t("leave-setting.dayWorkOnLeave")}
                                            </p>
                                        </div>
                                    }
                                    name="dayWorkOnLeave"
                                    labelAlign="right"
                                >
                                    <InputNumber/>
                                </Form.Item>
                            </Col>
                        </Row> : <></>
                    }*/}
                    <Row gutter={12} style={{marginBottom: "10px"}} >
                        <Col span={24}>
                            <div className={"flex__align--center"}>
                                <Form.Item
                                    name={"isAccumulationMonthly"}
                                    valuePropName={"checked"}
                                    initialValue={true}
                                    className={"margin--0"}
                                >
                                    <Switch onChange={(value)=>{
                                        if (value) {
                                            message.info(t("messageLeaveSetting.accumulate"))
                                        }else {
                                            message.info(t("messageLeaveSetting.deplete"))
                                        }
                                    }}/>
                                </Form.Item>
                                <span className={"px-4"}>
                                    {t("leave-setting.isAccumulationMonthly")}
                                </span>
                                <Tooltip
                                    placement="topLeft"
                                    title={t(
                                        "leave-setting.isAccumulationMonthlyDetail"
                                    )}
                                >
                                    <InfoCircleOutlined/>
                                </Tooltip>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.firstContractAllowed")}
                                labelDetail={`${t("leave-setting.firstContractAllowedDetails1")}
                                    ${t("leave-setting.firstContractAllowedDetails2")}
                                    ${t("leave-setting.firstContractAllowedDetails3")}
                                `}
                                name="firstContract"
                                initialValue={15}
                                {...styleFormItem}
                            >
                                <InputNumber style={{width: "100%"}}/>
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.accumulationEndTime")}
                                labelDetail={`${t("leave-setting.accumulationEndTimeDetails1")}
                                    ${t("leave-setting.accumulationEndTimeDetails2")}
                                `}
                                name="cumulativeEndTime"
                                initialValue={"no accumulation"}
                                {...styleFormItem}
                            >
                                <Select
                                    placeholder={t("placeholderLS.month")}
                                    onChange={(e) => chooseTypeCumulative(e)}
                                >
                                    {mapSelectCumulativeEndTime}
                                </Select>
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>
                    {
                        typeCumulative === "custom" || props.cumulativeEndtimeProps === "custom"
                            ? <>
                                <Row gutter={12}>
                                    <Col
                                        xxl={{span: 24}}
                                        xl={{span: 24}}
                                        lg={{span: 24}}
                                    >
                                        <Form.Item
                                            labelCol={{
                                                xxl: {span: 18},
                                                xl: {span: 18},
                                                lg: {span: 24},
                                            }}
                                            wrapperCol={{
                                                xxl: {span: 6},
                                                xl: {span: 6},
                                                lg: {span: 12},
                                            }}
                                            label={
                                                <div>
                                                    <p className="margin-b-5">
                                                        {t(
                                                            "leave-setting.dayEndCumulative"
                                                        )}
                                                    </p>
                                                </div>
                                            }
                                            name="dayEndCumulative"
                                            labelAlign="right"
                                        >
                                            <InputNumber/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={12}>
                                    <Col
                                        xxl={{span: 24}}
                                        xl={{span: 24}}
                                        lg={{span: 24}}
                                    >
                                        <Form.Item
                                            labelCol={{
                                                xxl: {span: 18},
                                                xl: {span: 18},
                                                lg: {span: 24},
                                            }}
                                            wrapperCol={{
                                                xxl: {span: 6},
                                                xl: {span: 6},
                                                lg: {span: 12},
                                            }}
                                            label={
                                                <div>
                                                    <p className="margin-b-5">
                                                        {t(
                                                            "leave-setting.monthEndCumulative"
                                                        )}
                                                    </p>
                                                </div>
                                            }
                                            name="monthEndCumulative"
                                            labelAlign="right"
                                        >
                                            <InputNumber/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                            : <></>
                    }
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.employeeLeaveNotAllowed")}
                                labelDetail={`${t("leave-setting.employeeLeaveNotAllowedDetails")}`}
                                name="beforeDayNoLeave"
                                {...styleFormItem}
                            >
                                <Select
                                    placeholder={t("placeholderLS.day")}
                                    allowClear={true}
                                >
                                    {mapSelectBeforeThisDay}
                                </Select>
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>
                    <Row gutter={12}>
                        <Col
                            xxl={{span: 24}}
                            xl={{span: 24}}
                            lg={{span: 24}}
                        >
                            <DG_FormItem_LabelDetail
                                label={t("leave-setting.employeeUnpaidNotAllowed")}
                                labelDetail={`${t("leave-setting.employeeUnpaidNotAllowedDetails1")}
                                    ${t("leave-setting.employeeUnpaidNotAllowedDetails2")}
                                `}
                                name="noSalaryNoLeave"
                                {...styleFormItem}
                            >
                                <Select
                                    placeholder={t("placeholderLS.day")}
                                    allowClear={true}
                                    style={{width: "100%"}}
                                >
                                    {mapSelectAfterThisDay}
                                </Select>
                            </DG_FormItem_LabelDetail>
                        </Col>
                    </Row>
                </Panel>
            </Collapse>
        </div>
    );
}

export default General;
